import { API_BASE_URL, apiClient, unwrap } from './apiClient';

async function list(path, params = {}) {
  const response = await apiClient.get(path, { params });
  return { data: unwrap(response), meta: response.meta || {} };
}

export const billingApi = {
  clientDashboard: async () => unwrap(await apiClient.get('/client/dashboard')),
  services: (params) => list('/services', params),
  addons: (params) => list('/addon-services', params),
  catalog: async (params = {}) => unwrap(await apiClient.get('/services/catalog', { params })),
  serviceDetail: async (id) => unwrap(await apiClient.get(`/services/${id}`)),
  availService: async (id, payload) => unwrap(await apiClient.post(`/services/${id}/avail`, payload)),
  createService: async (payload) => unwrap(await apiClient.post('/services', payload)),
  updateService: async (id, payload) => unwrap(await apiClient.patch(`/services/${id}`, payload)),
  deleteService: async (id) => unwrap(await apiClient.delete(`/services/${id}`)),
  createAddon: async (payload) => unwrap(await apiClient.post('/addon-services', payload)),
  updateAddon: async (id, payload) => unwrap(await apiClient.patch(`/addon-services/${id}`, payload)),
  deleteAddon: async (id) => unwrap(await apiClient.delete(`/addon-services/${id}`)),
  adminServiceRequests: (params) => list('/admin/service-requests', params),
  updateServiceRequestStatus: async (id, payload) => unwrap(await apiClient.patch(`/admin/service-requests/${id}/status`, payload)),
  convertServiceRequest: async (id, payload) => unwrap(await apiClient.post(`/admin/service-requests/${id}/convert`, payload)),
  assignUserService: async (userId, payload) => unwrap(await apiClient.post(`/users/${userId}/services`, payload)),
  adminUserServices: (params) => list('/admin/user-services', params),
  updateUserService: async (id, payload) => unwrap(await apiClient.patch(`/user-services/${id}`, payload)),
  myServices: (params) => list('/my/services', params),
  myAddons: (params) => list('/my/addons', params),
  renewalStatus: async () => unwrap(await apiClient.get('/my/service-renewal-status')),
  adminInvoices: (params) => list('/admin/invoices', params),
  createInvoice: async (payload) => unwrap(await apiClient.post('/admin/invoices', payload)),
  markPaid: async (id, payload) => unwrap(await apiClient.patch(`/admin/invoices/${id}/mark-paid`, payload)),
  approveInvoice: async (id, payload) => unwrap(await apiClient.post(`/admin/invoices/${id}/approve`, payload)),
  rejectInvoice: async (id, payload) => unwrap(await apiClient.post(`/admin/invoices/${id}/reject`, payload)),
  myInvoices: (params) => list('/my/invoices', params),
  getInvoice: async (id) => unwrap(await apiClient.get(`/invoices/${id}`)),
  deleteUserService: async (id) => unwrap(await apiClient.delete(`/user-services/${id}`)),
  upcomingInvoices: (params) => list('/my/invoices/upcoming', params),
  payInvoice: async (id, payload) => unwrap(await apiClient.post(`/invoices/${id}/pay`, payload)),
  invoiceDownloadUrl: (id) => `${API_BASE_URL}/invoices/${id}/download`,
  getInvoiceDownloadToken: async (id) => unwrap(await apiClient.post(`/invoices/${id}/download-token`)),
  ledger: (params) => list('/ledger', params),
  adminLedger: (params) => list('/admin/ledger', params),
  fundRequests: (params) => list('/fund-requests', params),
  createFundRequest: async (payload) => unwrap(await apiClient.post('/fund-requests', payload)),
  adminFundRequests: (params) => list('/admin/fund-requests', params),
  approveFundRequest: async (id, payload) => unwrap(await apiClient.patch(`/admin/fund-requests/${id}/approve`, payload)),
  rejectFundRequest: async (id, payload) => unwrap(await apiClient.patch(`/admin/fund-requests/${id}/reject`, payload))
};
